import { render } from "./SceneTrigger.vue?vue&type=template&id=fdc4ec08"
import script from "./SceneTrigger.vue?vue&type=script&lang=js"
export * from "./SceneTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script